import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule } from '@ngx-translate/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { MediaTabGalleryModule } from './media-tab-gallery/media-tab-gallery.module';
import { ConfirmationModalComponent, MediaTabComponent } from './media-tab.component';
import { MediaTabService } from './media-tab.service';
import { UploadImageDialogModule } from './upload-image-dialog/upload-image-dialog.module';

@NgModule({
  declarations: [MediaTabComponent, ConfirmationModalComponent],
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MediaTabGalleryModule,
    MatProgressBarModule,
    UploadImageDialogModule,
    MediaTabGalleryModule,
    MatIconModule,
    MatDialogModule,
    TranslateModule,
  ],
  providers: [MediaTabService, SnackbarService],
  exports: [MediaTabComponent],
})
export class MediaTabModule {}
